import PropTypes from 'prop-types';
import { Card, Spinner } from 'react-bootstrap';
import ReactMarkdown from 'react-markdown';
import React from 'react';
import remarkGfm from 'remark-gfm';

import MapPayload from './MapPayload';

/**
 * Chat message list used by the floating ChatWidget.
 */
export default function ChatMessages({
    messages,
    loading,
    loadingLabel,
    messagesEndRef,
}) {
    return (
        <div role="log" aria-live="polite" aria-label="Chat messages">
            {messages.map((message) => (
                <div key={message.id}>
                    <Card
                        className={`border-0 ${
                            message.sender === 'user'
                                ? 'bg-primary text-white'
                                : message.isError
                                  ? 'bg-danger-subtle'
                                  : 'bg-light'
                        }`}
                    >
                        <Card.Body className="p-3">
                            {message.sender === 'bot' ? (
                                <ReactMarkdown
                                    remarkPlugins={[remarkGfm]}
                                    components={{
                                        table: (props) => (
                                            <table
                                                className="table table-sm table-bordered mb-2"
                                                {...props}
                                            />
                                        ),
                                    }}
                                >
                                    {message.text}
                                </ReactMarkdown>
                            ) : (
                                message.text
                            )}
                            {/* Mirrored in BiliChat.jsx, which renders its own
                                message loop and does not use this component. */}
                            {message.sender === 'bot' && (
                                <MapPayload payload={message.map} />
                            )}
                        </Card.Body>
                    </Card>
                    <small className="text-muted">
                        {message.timestamp
                            ? message.timestamp.toLocaleTimeString([], {
                                  hour: '2-digit',
                                  minute: '2-digit',
                              })
                            : ''}
                    </small>
                </div>
            ))}
            {loading && (
                <div>
                    <Card className="border-0 bg-light">
                        <Card.Body className="p-3">
                            <Spinner
                                animation="border"
                                size="sm"
                                className="me-2"
                            />
                            {loadingLabel || 'Thinking...'}
                        </Card.Body>
                    </Card>
                </div>
            )}
            <div ref={messagesEndRef} />
        </div>
    );
}

ChatMessages.propTypes = {
    messages: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            text: PropTypes.string.isRequired,
            sender: PropTypes.string.isRequired,
            timestamp: PropTypes.instanceOf(Date),
            isError: PropTypes.bool,
            /** Payload Contract `map` object; absent when the turn has no map */
            map: PropTypes.shape({
                render_type: PropTypes.string,
                embed_code: PropTypes.string,
                fallback_url: PropTypes.string,
                embeddable: PropTypes.bool,
                source: PropTypes.shape({
                    name: PropTypes.string,
                }),
            }),
        })
    ).isRequired,
    loading: PropTypes.bool,
    loadingLabel: PropTypes.string,
    messagesEndRef: PropTypes.object,
};
